import { RadioFieldModel } from '@types'

import { RadioGroup } from '@components/RadioGroup'

type SubmitterFieldRadioProps = {
  field: RadioFieldModel
  disabled?: boolean
  onChange: (updates: Partial<RadioFieldModel>) => void
  onRedirect: (id: string) => void
}

export const SubmitterFieldRadio: React.FC<SubmitterFieldRadioProps> = ({
  field,
  disabled = false,
  onChange,
  onRedirect,
}: SubmitterFieldRadioProps) => {
  const options = field.options.map((option) => ({
    value: option.id,
    label: option.label,
    id: option.id,
  }))

  return (
    <RadioGroup
      name={`radio-group-${field.id}-${field.label}`}
      label={field.label}
      required={field.required}
      options={options}
      value={field.value}
      disabled={disabled}
      onChange={(value) => {
        const option = field.options.find((option) => option.id === value)
        option?.redirectTo && onRedirect(option.redirectTo)

        onChange({ value })
      }}
    />
  )
}
